import React, { useState } from "react"
import { Switch } from "@lrewater/lre-react"
import LreReactLayout from "./LreReactLayout"

const SwitchExample = props => {
  const [active, setActive] = useState(true)

  const handleChange = event => {
    const newValue = event.target.value
    setActive(newValue)
  }

  return (
    <LreReactLayout>
      <Switch
        name="switch_primary_example"
        color="primary"
        label={active ? "Color Primary | Active" : "Color Primary |  Inactive"}
        value="switch_primary_example"
        checked={active}
        onChange={handleChange}
      />
      <Switch
        name="switch_secondary_example"
        color="secondary"
        label={
          active ? "Color Secondary | Active" : "Color Secondary |  Inactive"
        }
        value="switch_secondary_example"
        checked={active}
        onChange={handleChange}
      />
    </LreReactLayout>
  )
}

export default SwitchExample
